import { MessageSquare } from 'lucide-react';

interface CompanyLogoProps {
  variant?: 'light' | 'dark';
  showText?: boolean;
  size?: 'sm' | 'md';
}

export function CompanyLogo({
  variant = 'light',
  showText = true,
  size = 'md',
}: CompanyLogoProps) {
  const isLight = variant === 'light';
  const iconSize = size === 'sm' ? 'h-9 w-9' : 'h-11 w-11';
  const iconInner = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';

  return (
    <div className="flex items-center gap-3">
      <div
        className={`${iconSize} flex shrink-0 items-center justify-center rounded-2xl shadow-lg ${
          isLight
            ? 'bg-white/20 ring-1 ring-white/30 backdrop-blur-sm'
            : 'bg-[#2563EB] shadow-blue-600/25'
        }`}
        aria-hidden="true"
      >
        <MessageSquare
          className={`${iconInner} ${isLight ? 'text-white' : 'text-white'}`}
          strokeWidth={2}
        />
      </div>
      {showText && (
        <span
          className={`font-semibold tracking-tight ${
            size === 'sm' ? 'text-sm' : 'text-base'
          } ${isLight ? 'text-white' : 'text-[#0F172A]'}`}
        >
          Cignalex
        </span>
      )}
    </div>
  );
}
